module.exports = __webpack_public_path__ + "img/service-02.96d2536f.svg";